import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import orderBy from 'lodash/orderBy'

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { InputTextarea } from 'primereact/inputtextarea';

import Header from '@components/Header';
import CategoriesSectionTree from '@components/CategorieSectionTree'
import JustificationModal from '@components/JustificationModal';
import DeleteAuthorizedModal from '@components/Section/DeleteAuthorizedModal';


import { getSections, updateVisibilityStatus, deleteSection, reOrderSections, getDetailSection } from '@actions/sections';
import { validatePermissionAction, validateCountriesSectionsAllowed } from '@actions/sessionPermission';
import { sendActionToBitacora  } from '@actions/bitacora';

import { getValueLanguageObj, findSectionInTree } from '@utils/general';

import { AuthorizedStatus, StatusVisible, StatusDelete, LANGUAGE_DEFAULT } from '@constants/general'
import catalogPermissionsId from '@constants/catalogPermissionsId'

import './style.scss'

const MAX_SECTIONTS = 4


class Sections extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingTable: true,
      sectionList: [],
      totalRecords: 0,
      lazyParams: {
        first: 0,
        rows: 10,
        page: 0,
      },
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
      showModal: {
        isVisible: false,
        title: '',
        children: null,
        textOk: '',
        textHide: '',
        actionOk: null,
        actionHide: () => {},
      },
      showModalDeleteAuthorized: {
        isVisible: false,
        data: null
      },
      selectedNavegationTree: '',
      selectedNavegationTreeSearch: '',
      selectedLabelNavegationTree: '',
      findCategory: '',
      justificationRemove: '',
      transactionNameOpt: ''
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    const { getSections, allowedSections } = this.props;
    const { selectedNavegationTree, findCategory } = this.state;
    this.setState({ loadingTable: true });
    const params = {
      type: 'all',
    };
    if (selectedNavegationTree ) params.section = selectedNavegationTree;
    // if (selectedNavegationTree && selectedNavegationTree !== DEFAULT_SECTION) params.section = selectedNavegationTree;
    // if (findCategory) params.find = findCategory;

    console.log('params', params);

    const response = await getSections(params);
    if (!response?.status) {

      if (!selectedNavegationTree && allowedSections?.navega === 'SOME') response.data = [] // Valida para que no se muestre resultado HOME
      
      
      if (response.data.length) {
        
        response.data = this.validateSectionsByCountriesAllowed(response.data) // Valida secciones de tipo pais

        response.data = orderBy(response.data, 'orden', 'asc')
        if (findCategory) {
          response.data = response.data.filter(item => {
            const getCurrentName = getValueLanguageObj(item.nombre).toUpperCase()
            return getCurrentName.includes(findCategory.toUpperCase())
          })
        }
      }
      return this.setState({
        sectionList: response.data,
        selectedNavegationTreeSearch: selectedNavegationTree,
        loadingTable: false,
      });
    }
    return this.setState({ loadingTable: false });
  };

  validateSectionsByCountriesAllowed = (data) => {
    const { validateCountriesSectionsAllowed, allowedPaisess } = this.props;
    const { selectedLabelNavegationTree } = this.state;
    const dividerSectionParent = selectedLabelNavegationTree.split("/")
    const isLandingCountries = dividerSectionParent.length === MAX_SECTIONTS
    if (isLandingCountries && allowedPaisess?.navega === "SOME") {
      return validateCountriesSectionsAllowed(data)
    }
    return data
  }

  onPage = (event) => {
    const { lazyParams } = this.state;
    const _lazyParams = { ...lazyParams, ...event };
    console.log('event onPage', event);
    this.setState({ lazyParams: _lazyParams }, this.loadData);
  };

  sendCommentToBitacora = async (data, justification) => {
    const { sendActionToBitacora, getDetailSection } = this.props
    const { transactionNameOpt } = this.state
    let nameSection = ''
    if (data.id_original) {
      const response = await getDetailSection({id: data.id_original})
      if (!response?.status) nameSection = response.data.nombre[LANGUAGE_DEFAULT]
      else nameSection = data.nombre[LANGUAGE_DEFAULT]
    } else {
      nameSection = data.nombre[LANGUAGE_DEFAULT]
    }
    const dataBitacora = {
      transactionName: transactionNameOpt || 'Seccion',
      reason: `${nameSection} || ${justification}`,
    }
    await sendActionToBitacora(dataBitacora)
  }

  onConfirmVisible = (data) => {
    console.log('data', data)
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        continueAction: ({justification}) => this.onChangeVisibleStatus(data, justification),
      },
    });
  };

  onChangeVisibleStatus = async (data, justification) => {
    const { t, updateVisibilityStatus } = this.props
    this.setState({loadingTable: true})
    const response = await updateVisibilityStatus({...data, justification});
    if (!response?.status) {
      await this.setState({transactionNameOpt: data.visible === StatusVisible.IS_VISIBLE ? 'ocultarSeccion' : 'mostrarSeccion' })
      await this.sendCommentToBitacora(data, justification)
      this.loadData()
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    return this.setState({loadingTable: false});
  };

  onConfirmDeleteSeccion = (data) => {
    const { t,categoriesSectionCatalog } = this.props;
    const findInTree = findSectionInTree(data.id, categoriesSectionCatalog)
    const findSectionsToDelete = this.findChildrensLabels(findInTree)

    const descriptionAlt = (
      <div>
        <br/>
        <p>{t('Considere que la sección tiene la siguiente estructura que también será eliminada.')}</p>
        {findSectionsToDelete.map(item => (<ul key={item}>{item}</ul>))}
      </div>
    )

    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('Eliminación de una sección autorizada'),
        description: t('¿Esta seguro que desea eliminar esta sección?'),
        label: t('Justificación de la eliminación'),
        btnOkLabel: t('Eliminar sección'),
        descriptionAlt,
        continueAction: ({justification}) => this.onDeleteSection(data, justification),
      },
    });
  };

  findChildrensLabels = (data, accum = []) => {
    accum.push(data.label)
    if (data?.children) {
      data.children.map(item => {
        return this.findChildrensLabels(item, accum)
      })
    }
    return accum
  }

  onConfirmDeleteAuthorized = (data) => {
    this.setState({
      showModalDeleteAuthorized: {
        isVisible: true,
        data
      }
    });
  }

  onDeleteSection = async (node, justification) => {
    const { t, deleteSection } = this.props
    this.setState({loadingTable: true})
    const type = "logical"
    const response = await deleteSection({...node, justification, type});
    if (!response?.status) {
      await this.setState({transactionNameOpt: 'bajaSeccion' })
      await this.sendCommentToBitacora(node, justification)
      await this.loadData();
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    return this.setState({loadingTable: false})
  };

  onEditSection = async (node) => {
    const { history } = this.props
    history.push({pathname: '/section/edit', state: {clearCache: true, id: node.id}})
  }

  onPendingSection = async (node) => {
    const { history } = this.props;
    history.push({
      pathname: '/section/edit',
      state: { clearCache: true, id: node.id, isPending: true },
    });
  };

  templateName = (node, detail) => (
      <>
        <span className="p-column-title">{detail.header}</span>
        {getValueLanguageObj(node.nombre)}
      </>
    );

  templateAuthorized = (node, detail) => {
    const { t } = this.props;
    if (node.estatus === AuthorizedStatus.STATUS_AUTHORIZED) {
      return (
        <div className="p-text-center-lg">
          <span className="p-column-title">{detail.header}</span>
          <i className="pi pi-check p-mr-2"></i>
        </div>
      );
    }
    if (node.estatus === AuthorizedStatus.STATUS_PENDING) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-blue cursor-pointer" onClick={() => this.onPendingSection(node)}> {t('PENDIENTE')} </span>
        </>
      );
    }
    if (node.estatus === AuthorizedStatus.STATUS_EDITION) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-green"> {t('EN EDICIÓN')} </span>
        </>
      )
    }
    if (node.estatus === AuthorizedStatus.STATUS_REJECTED) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-red"> {t('RECHAZADO')} </span>
        </>
      );
    }
    return (<span className="p-column-title">{detail.header}</span>);
  };

  templateVisible = (node, detail) => {
    const { t, validatePermissionAction } = this.props;
    const hasPermissioShowHiddeSection = validatePermissionAction(catalogPermissionsId.MOSTRAR_OCULTAR_SECCION)
    if (node.visible === StatusVisible.IS_VISIBLE && node.estatus === AuthorizedStatus.STATUS_AUTHORIZED && node.eliminado === StatusDelete.IS_VISIBLE ) {
      return (
        <div className="p-text-center-lg">
          <span className="p-column-title">{detail.header}</span>
          <Button
            type="button"
            icon="pi pi-check"
            className={`p-button-text ${hasPermissioShowHiddeSection ? 'cursor-pointer' : 'cursor-not-pointer'}`}
            style={{ marginRight: '.5em' }}
            onClick={hasPermissioShowHiddeSection ? () => this.onConfirmVisible(node) : () => {}}
          />
        </div>
      );
    }
    if (node.visible === StatusVisible.IS_VISIBLE && node.id_original !== 0) {
      return (
        <div className="p-text-center-lg">
          <span className="p-column-title">{detail.header}</span>
          <i className={`pi pi-check cursor-pointer ${hasPermissioShowHiddeSection ? 'cursor-pointer' : 'cursor-not-pointer'}`} onClick={hasPermissioShowHiddeSection ? () => this.onConfirmVisible(node) : () => {}}/>
        </div>
      );
    }
    if (node.visible === StatusVisible.IS_VISIBLE) {
      return (
        <div className="p-text-center-lg">
          <span className="p-column-title">{detail.header}</span>
          <i className="pi pi-check" />
        </div>
      );
    }
    if (node.visible === StatusVisible.IS_HIDDEN && (node.estatus === AuthorizedStatus.STATUS_AUTHORIZED || node.id_original !== 0)) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className={`badge-red ${hasPermissioShowHiddeSection ? 'cursor-pointer' : 'cursor-not-pointer'}`} aria-hidden="true" onClick={hasPermissioShowHiddeSection ? () => this.onConfirmVisible(node) : () => {}}> {t('OCULTA')} </span>
        </>
      );
    }
    if (node.visible === StatusVisible.IS_HIDDEN) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className={`badge-red cursor-not-pointer`} aria-hidden="true" > {t('OCULTA')} </span>
        </>
      );
    }
    return (<span className="p-column-title">{detail.header}</span>);
  };

  templateEdit = (node, detail) => {
    const { validatePermissionAction } = this.props
    const hasEditAllSection = validatePermissionAction(catalogPermissionsId.EDITAR_TODAS_SECCIONES)
    if (node.estatus === AuthorizedStatus.STATUS_AUTHORIZED && !hasEditAllSection) {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
        </div>
      )
    }
    if ( node.eliminado !== StatusDelete.CONFIRM_DELETE ) {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <Button
            type="button"
            icon="pi pi-pencil"
            className="p-button-text"
            style={{ marginRight: '.5em' }}
            onClick={() => this.onEditSection(node)}
          />
        </div>
      )
    }
    return (
      <div>
        <span className="p-column-title">{detail.header}</span>
      </div>
    )
  };

  templateDelete = (node, detail) => {
    const { t } = this.props
    // if (node.authorizedId !== AuthorizedStatus.STATUS_AUTHORIZED)
    //   return (<span className="p-column-title">{detail.header}</span>);
    if (node.estatus === AuthorizedStatus.STATUS_AUTHORIZED && node.eliminado === StatusDelete.CONFIRM_DELETE) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-yellow cursor-pointer" onClick={() => this.onConfirmDeleteAuthorized(node)}> {t('Eliminado')} </span>
        </>
      )
    }
    if (node.estatus === AuthorizedStatus.STATUS_AUTHORIZED && node.eliminado === StatusDelete.IS_VISIBLE) {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <Button
            type="button"
            icon="pi pi-trash"
            className="p-button-text"
            style={{ marginRight: '.5em' }}
            onClick={() => this.onConfirmDeleteSeccion(node)}
          />
        </div>
      );
    }
    return (
      <div>
        <span className="p-column-title">{detail.header}</span>
      </div>
    )
  };

  onHideModal = () => {
    this.setState({
      showModalJustification: {
        isVisible: false,
      },
    });
  };

  onHideModalDeleteAuthorized = () => {
    this.setState({
      showModalDeleteAuthorized: {
        isVisible: false,
      },
    });
  };

  onChange = ({target}) => {
    this.setState({ [target.name]: target.value });
  };

  onChangeCategoriesSection = ({value, label}) => {
    this.setState({selectedNavegationTree: value, selectedLabelNavegationTree: label})
  }

  onRowReorder = async (newOrden) => {
    const { reOrderSections } = this.props
    const { sectionList } = this.state
    const formatData = newOrden.value.reduce((accum, item, index) => {
      if (item?.id_original !== 0) accum.push({ id: item.id_original, orden: sectionList[index].orden})
      accum.push({ id: item.id, orden: sectionList[index].orden})
      return accum
    }, [])
    const response = await reOrderSections(formatData)
    if (!response.status) {
      this.setState({sectionList: newOrden.value})
    }
  }

  render() {
    const { history, t, validatePermissionAction } = this.props;
    const {
      loadingTable,
      sectionList,
      totalRecords,
      lazyParams,
      showModal,
      selectedLabelNavegationTree,
      selectedNavegationTree,
      findCategory,
      showModalJustification,
      showModalDeleteAuthorized,
      selectedNavegationTreeSearch
    } = this.state;

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
        { validatePermissionAction(catalogPermissionsId.CREAR_EDITAR_SECCION) && (
          <Button
            label={t('Agregar Seccion')}
            className="p-button-primary"
            onClick={() => history.push({pathname: '/section/new', state: {clearCache: true, selectedNavegationTree: selectedNavegationTreeSearch}})}
          />
        )}
      </>
    );

    const headerTable = (
      <div className="p-grid">
        <div className="p-col-12 p-md-7 p-lg-7 p-d-flex p-ai-center">
          <label className="p-mr-2 p-text-bold">{t('Filtrado por')}:</label>{' '}
          <CategoriesSectionTree
            value={selectedNavegationTree}
            label={selectedLabelNavegationTree}
            onChangeCategorie={this.onChangeCategoriesSection}
          />
        </div>
        <div className="p-col-12 p-md-5 p-lg-5 p-d-flex p-ai-center p-flex-column p-flex-sm-row p-jc-sm-center ">
          <div className="p-col p-d-flex p-ai-center is-full-width">
            <label className="p-mr-2 p-text-bold">{t('Texto')}:</label>
            <InputText
              name="findCategory"
              value={findCategory}
              onChange={this.onChange}
              className="p-mr-2 input-search-list"
            />
          </div>
          <div className="p-col is-full-width">
            <Button
              icon="pi pi-search"
              label={t('Buscar')}
              className="p-button-raised p-button-text p-button-plain btn-search-list"
              onClick={() => this.loadData()}
            />
          </div>
        </div>
      </div>
    );

    const footerModal = (
      <div>
        {showModal.actionHide && (
          <Button label={showModal.textHide} onClick={showModal.actionHide} />
        )}
        {showModal.actionOk && (
          <Button label={showModal.textOk} onClick={showModal.actionOk} />
        )}
      </div>
    );

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Secciones')} rightComponent={rightHeader} />
          <div className="card">
            <DataTable
              value={sectionList}
              lazy
              // paginator
              // rows={lazyParams.rows}
              loading={loadingTable}
              // totalRecords={totalRecords}
              first={lazyParams.first}
              // onPage={this.onPage}
              header={headerTable}
              className="table-section-list"
              onRowReorder={this.onRowReorder}
            >
              { validatePermissionAction(catalogPermissionsId.ORDENAR_SECCION) && (
                <Column
                  rowReorder
                  style={{width: '4em'}}
                  header={t('Orden')}
                  className="sm-invisible"
                />
              )}
              <Column header={t('Nombre')} body={this.templateName} />
              <Column
                header={t('Autorizado')}
                body={this.templateAuthorized}
                className="column-authorized"
              />
              { (validatePermissionAction(catalogPermissionsId.CREAR_EDITAR_SECCION) || validatePermissionAction(catalogPermissionsId.EDITAR_TODAS_SECCIONES))  && (
                <Column
                  header={t('Editar')}
                  body={this.templateEdit}
                  className="column-action"
                />
              )}
              <Column
                header={t('Visible')}
                body={this.templateVisible}
                className="column-action"
              />
              { validatePermissionAction(catalogPermissionsId.ELIMINAR_SECCION_AUTORIZADAS) && (
                <Column
                  header={t('Eliminar')}
                  body={this.templateDelete}
                  className="column-action"
                />
              )}
            </DataTable>
            { !sectionList.length && !loadingTable && (
              <div className="p-col-12 not-information">
                {t('No se encontraron resultados')}
              </div>
            )}
          </div>
        </div>
        <Dialog
          header={showModal.title}
          visible={showModal.isVisible}
          breakpoints={{'960px': '75vw'}}
          style={{ width: '35vw' }}
          footer={footerModal}
          onHide={showModal.actionHide}
        >
          {showModal.children}
        </Dialog>
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          descriptionAlt={showModalJustification.descriptionAlt}
          label={showModalJustification.label}
          btnOkLabel={showModalJustification.btnOkLabel}
          onHidden={() => this.onHideModal()}
          onContinueAction={showModalJustification.continueAction}
        />
        <DeleteAuthorizedModal
          display={showModalDeleteAuthorized.isVisible}
          data={showModalDeleteAuthorized.data}
          onHidden={() => this.onHideModalDeleteAuthorized()}
          onContinueAction={() => this.loadData()}
          sectionTree={selectedNavegationTreeSearch}

        />
        <Toast ref={(el) => (this.toast = el)} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  categoriesSectionCatalog: state.catalogs.sectionTreeCurrentCatalog,
  allowedSections: state.sessionPermission.secciones,
  allowedPaisess: state.sessionPermission.paises,
  countriesCatalog: state.catalogs.countriesCatalog,
})

const mapDispatchToProps = {
  getSections,
  updateVisibilityStatus,
  deleteSection,
  reOrderSections,
  validatePermissionAction,
  validateCountriesSectionsAllowed,
  getDetailSection,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
  )(Sections);
